import React, {Component} from 'react';
import moment from 'moment';

import classNames from 'classnames';
import {TEST_USER_INFO_LABELS} from '../../../constants/index';
import strings from 'utils/strings';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPrint} from '@fortawesome/free-solid-svg-icons';

const childTypeGrades = [
	'child-screening',
	'child',
	'youth-screening',
	'youth-followup',
];
const InfoRow = (props) => {
	if (props.condition !== undefined && !props.condition) {
		return null;
	}
	return (
		<p className="info__row">
			<span className="info__label">{props.name}</span>
			<span className="info__value">{props.children || props.value}</span>
		</p>
	);
};
const InfoRowBool = (props) => {
	const value = props.children || props.value;
	const hasLongIntro = props.hasLongIntro;
	const notAvailable = props.notAvailable;
	const valueText =
		value === 'yes' || value === 'ja' || value === true
			? 'Ja'
			: value === true || value === 'true'
			? 'Ja'
			: value === 'no' || value === 'nei' || value === false
			? 'Nei'
			: value === ''
			? notAvailable
			: hasLongIntro && typeof value === 'undefined'
			? notAvailable
			: hasLongIntro && value
			? 'Ja'
			: hasLongIntro && !value
			? 'Nei'
			: !hasLongIntro && !value
			? 'Nei'
			: '';

	return (
		<InfoRow condition={props.condition} name={props.name}>
			{valueText}
		</InfoRow>
	);
};

class TestUserInfo extends Component {
	render() {
		const {testResult} = this.props;
		const {
			testResult: {
				subtests: [{language}],
			},
			testReportLang,
		} = this.props;

		const {testUser} = testResult;
		const testCompletionDate = moment(testResult.completedAt, 'YYYY-MM-DD');
		const requiredDate = moment('2022-04-23').format('YYYY-MM-DD');
		const timeDifference = moment(testCompletionDate).diff(
			requiredDate,
			'days'
		);
		if (timeDifference > 1) {
		}

		const hasLongIntro = Boolean(testResult.anamnese);
		const isTestOwner = testResult.isTestOwner;

		const completeName = testUser.firstName
			? `${testUser.firstName} ${testUser.lastName}`
			: strings.hiddenname;
		const completeEmail = testUser.firstName
			? `${testUser.email}`
			: '<Skjult Epost>';
		const notAvailable =
			testReportLang === 'nn'
				? strings._props.nn.notavailable
				: strings.notavailable;

		const monthString =
			testReportLang === 'nn' ? strings._props.nn.months : strings.months;
		return (
			<div>
				<div className="lit-input-information">
					<button
						className={classNames('print-hide', {
							'lit-btn2 see-more': true,
							'bg-tertiary': true,
						})}
						onClick={() => {
							window.print();
							/* this.updatePrintLog('Results'); */
						}}
					>
						<FontAwesomeIcon
							size="lg"
							className="lit-icon-btns"
							icon={faPrint}
						/>

						<p className="lit-btns-txt">{strings.printInformation}</p>
					</button>
				</div>
				<div className="info">
					<InfoRow
						condition={isTestOwner}
						name={strings.nameColonNoSpace}
						hasLongIntro={hasLongIntro}
					>{`${completeName}`}</InfoRow>
					{this.props.testType === 'child-screening' && (
						<InfoRow
							condition={testUser.education.isInHighSchool}
							hasLongIntro={hasLongIntro}
							name={strings.gradeColonLabel}
						>
							{testUser.education.youthGrade}
						</InfoRow>
					)}
					<InfoRow
						name={strings.dateOfCompletion}
						value={moment(testResult.completedAt).format('LL')}
					/>

					<InfoRow
						condition={isTestOwner}
						name={strings.emailColon}
						value={completeEmail}
						hasLongIntro={hasLongIntro}
					/>
					<InfoRow
						condition={isTestOwner}
						name={strings.telephoneColon}
						value={testUser.phone}
						hasLongIntro={hasLongIntro}
					/>

					<InfoRow
						name={strings.ageAtCompletion}
						value={strings.formatString(
							strings.ageYearsAndMonths,
							testUser.age.years,
							testUser.age.months,
							monthString
						)}
						hasLongIntro={hasLongIntro}
					/>
					<InfoRow
						name={strings.genderColon}
						value={
							testUser.gender === 'm' &&
							childTypeGrades.includes(this.props.testType)
								? strings.boy
								: testUser.gender === 'f' &&
								  childTypeGrades.includes(this.props.testType)
								? strings.girl
								: testUser.gender === 'm' &&
								  !childTypeGrades.includes(this.props.testType)
								? strings.male
								: testUser.gender === 'f' &&
								  !childTypeGrades.includes(this.props.testType)
								? strings.female
								: notAvailable
						}
						hasLongIntro={hasLongIntro}
					/>
					{this.props.testType !== 'child-screening' && (
						<div className="info__group info__group--education">
							<h3>{strings.education}</h3>
							{testUser.education && (
								<>
									<InfoRow
										name={strings.highestEducation}
										hasLongIntro={hasLongIntro}
									>
										{testUser.education
											.highestCompletedEducation ===
											'juniorHigh' &&
											strings.educationJuniorHigh}
										{testUser.education
											.highestCompletedEducation ===
											'highSchool' &&
											strings.educationHighSchool}
										{testUser.education
											.highestCompletedEducation ===
											'bachelor' && strings.bachelor}
										{testUser.education
											.highestCompletedEducation ===
											'master' && strings.educationMaster}
										{testUser.education
											.highestCompletedEducation ===
											'phd' && strings.educationPhd}
										{testUser.education
											.highestCompletedEducation ===
											'other' && strings.genderOther}
									</InfoRow>
									{testUser.education
										.highestCompletedEducation ===
										'other' && (
										<InfoRow
											name={strings.otherCompetence}
											hasLongIntro={hasLongIntro}
										>
											{testUser.education.otherEducation}
										</InfoRow>
									)}

									<InfoRowBool
										notAvailable={notAvailable}
										name={strings.goesToHighSchool}
										value={
											testUser.education.isInHighSchool
										}
										hasLongIntro={hasLongIntro}
									/>
									{this.props.testType !==
										'child-screening' && (
										<InfoRow
											condition={
												testUser.education
													.isInHighSchool
											}
											name={strings.educationProgramColon}
											hasLongIntro={hasLongIntro}
										>
											{testUser.education
												.vocationalEducation
												? strings.vocational
												: strings.studyPreparingProgram}
										</InfoRow>
									)}

									<InfoRow
										condition={
											testUser.education.isInHighSchool
										}
										hasLongIntro={hasLongIntro}
										name={strings.gradeColonLabel}
									>
										{this.props.testType ===
										'adult-screening'
											? testUser.education.grade
											: testUser.education.youthGrade ||
											  testUser.class}
									</InfoRow>
									{!testUser.education.isInHighSchool && (
										<>
											<InfoRowBool
												notAvailable={notAvailable}
												name={
													strings.onWorkAssessmentAllowanceQuestion
												}
												value={
													testUser.education
														.onWorkAssessmentAllowance
												}
												hasLongIntro={hasLongIntro}
											/>

											<InfoRow
												condition={
													testUser.education
														.onWorkAssessmentAllowance
												}
												name={strings.measureColon}
												hasLongIntro={hasLongIntro}
											>
												{testUser.education.measure ===
													'youthProgram' &&
													strings.measureYouthProgram}
												{testUser.education.measure ===
													'accompanyingMeasures' &&
													strings.measureAccompanyingMeasures}
												{testUser.education.measure ===
													'workPreparatoryTraining' &&
													strings.measureWorkPreparatoryTraining}
											</InfoRow>

											{!testUser.education
												.onWorkAssessmentAllowance && (
												<>
													<InfoRowBool
														notAvailable={
															notAvailable
														}
														name={
															strings.adultEducationQuestion
														}
														value={
															testUser.education
																.isDoingAdultEducation
														}
														hasLongIntro={
															hasLongIntro
														}
													/>
													<InfoRowBool
														notAvailable={
															notAvailable
														}
														condition={
															!testUser.education
																.isDoingAdultEducation
														}
														name={
															strings.higherEducationQuestion
														}
														value={
															testUser.education
																.isDoingHigherEducation
														}
														hasLongIntro={
															hasLongIntro
														}
													/>
												</>
											)}
										</>
									)}
								</>
							)}
						</div>
					)}
					<div className="info__group">
						{this.props.testType !== 'child-screening' ? (
							<h3>{strings.homeLanugage}</h3>
						) : (
							''
						)}

						{this.props.testType !== 'child-screening' && (
							<InfoRowBool
								notAvailable={notAvailable}
								name={strings.grewUpBilingualHomeQuestion}
								value={
									testUser.homeLanguage.grewUpInBilingualHome
								}
								hasLongIntro={hasLongIntro}
							/>
						)}

						{this.props.testType !== 'child-screening' &&
							testUser.homeLanguage.grewUpInBilingualHome && (
								<>
									<InfoRow
										name={strings.firstLanguageQuestion}
										hasLongIntro={hasLongIntro}
									>
										{
											TEST_USER_INFO_LABELS[
												testUser.homeLanguage
													.firstLanguage
											]
										}
									</InfoRow>
									<InfoRow
										condition={
											testUser.homeLanguage
												.firstLanguage === 'other'
										}
										hasLongIntro={hasLongIntro}
										name={strings.otherFirstLanguageLabel}
										value={
											testUser.homeLanguage
												.otherFirstLanguage
										}
									/>
									<InfoRow
										name={strings.secondLanguageQuestion}
										hasLongIntro={hasLongIntro}
										value={
											TEST_USER_INFO_LABELS[
												testUser.homeLanguage
													.secondLanguage
											]
										}
									/>
									<InfoRow
										condition={
											testUser.homeLanguage
												.secondLanguage === 'other'
										}
										hasLongIntro={hasLongIntro}
										name={strings.otherSecondLanguageLabel}
										value={
											testUser.homeLanguage
												.otherSecondLanguage
										}
									/>
								</>
							)}
					</div>

					{this.props.testType !== 'child-screening' && (
						<div>
							<div className="info__group info__group--language">
								<h3>{strings.language}</h3>
								<InfoRowBool
									notAvailable={notAvailable}
									name={
										strings.troubleRememberingWordQuestion
									}
									hasLongIntro={hasLongIntro}
									value={
										testUser.language
											.troubleRememberingWhichWordToSay
									}
								></InfoRowBool>
								<InfoRowBool
									notAvailable={notAvailable}
									name={strings.shufflesWordsQuestion}
									hasLongIntro={hasLongIntro}
									value={
										testUser.language
											.shufflesWordsWhenSpeaking
									}
								></InfoRowBool>
								<InfoRowBool
									notAvailable={notAvailable}
									name={
										strings.longTimeFormulatingQuestion
									}
									hasLongIntro={hasLongIntro}
									value={
										testUser.language
											.spendsLongTimeFormulatingCorrectly
									}
								></InfoRowBool>
								<InfoRowBool
									notAvailable={notAvailable}
									name={
										strings.suspicionLanguageDifficultiesQuestion
									}
									hasLongIntro={hasLongIntro}
									value={
										testUser.language
											.hasBeenSuspicionsOfDifficulties
									}
								></InfoRowBool>
								<InfoRowBool
									notAvailable={notAvailable}
									name={
										strings.assessedLanguageDifficultiesQuestion
									}
									value={
										testUser.language
											.hasBeenAssessedForDifficulties
									}
									hasLongIntro={hasLongIntro}
								/>
								<InfoRowBool
									notAvailable={notAvailable}
									condition={
										testUser.language
											.hasBeenAssessedForDifficulties
									}
									hasLongIntro={hasLongIntro}
									name={strings.diagnosisLanguageQuestion}
									value={testUser.language.hasDiagnosis}
								/>

								<InfoRowBool
									notAvailable={notAvailable}
									condition={
										!testUser.language
											.hasBeenAssessedForDifficulties
									}
									hasLongIntro={hasLongIntro}
									name={
										strings.suspectLanguageDifficultiesQuestion
									}
									value={
										testUser.language
											.suspectsToHaveDifficulties
									}
								/>
								<InfoRow
									name={
										strings.familyLanguageDifficultiesQuestion
									}
									hasLongIntro={hasLongIntro}
								>
									{testUser.language
										.closeRelativeHasDifficulties ===
										'yes' && 'Ja'}
									{testUser.language
										.closeRelativeHasDifficulties ===
										'no' && 'Nei'}
									{testUser.language
										.closeRelativeHasDifficulties ===
										'doesNotKnow' && strings.answerDoesNotKnow}
								</InfoRow>
								<InfoRow
									name={strings.rateOwnOralLanguageQuestion}
									value={testUser.language.selfRating}
									hasLongIntro={hasLongIntro}
								/>
							</div>
						</div>
					)}
					{testUser.readingAndWriting &&
						this.props.testType === 'child-screening' && (
							<div className="info__group info__group--reading-and-writing">
								<h3>{strings.readingAndWritingHeading}</h3>
								<p className="indent"></p>
								<InfoRowBool
									notAvailable={notAvailable}
									name={
										strings.childDiagnosedReadingWritingQuestion
									}
									value={
										testUser.readingAndWriting
											.hasBeenAssessedForDifficulties
									}
									hasLongIntro={hasLongIntro}
								/>
								<InfoRowBool
									notAvailable={notAvailable}
									name={
										strings.childSuspectedReadingWritingQuestion
									}
									value={
										testUser.readingAndWriting
											.suspectsToHaveDyslexia
									}
									hasLongIntro={hasLongIntro}
								/>
							</div>
						)}

					{testUser.readingAndWriting &&
						this.props.testType !== 'child-screening' && (
							<div className="info__group info__group--reading-and-writing">
								<h3>{strings.readingAndWritingHeading}</h3>
								<p className="indent">
									<strong>
										{strings.difficultiesWithIntro}
									</strong>
								</p>
								<InfoRowBool
									notAvailable={notAvailable}
									name={strings.difficultyReadWordsCorrectly}
									value={
										testUser.readingAndWriting
											.difficultiesWith
											.readingWordsCorrectly
									}
									hasLongIntro={hasLongIntro}
								/>
								<InfoRowBool
									notAvailable={notAvailable}
									name={strings.difficultyReadLongTexts}
									value={
										testUser.readingAndWriting
											.difficultiesWith.readLongTexts
									}
									hasLongIntro={hasLongIntro}
								/>
								<InfoRowBool
									notAvailable={notAvailable}
									name={strings.difficultyRememberWhatRead}
									value={
										testUser.readingAndWriting
											.difficultiesWith
											.rememberingWhatYouHaveRead
									}
									hasLongIntro={hasLongIntro}
								/>
								<InfoRowBool
									notAvailable={notAvailable}
									name={strings.difficultyWriteWordsCorrectly}
									value={
										testUser.readingAndWriting
											.difficultiesWith.writeWordsProperly
									}
									hasLongIntro={hasLongIntro}
								/>
								<InfoRowBool
									notAvailable={notAvailable}
									name={strings.difficultyGetThoughtsOnPaper}
									value={
										testUser.readingAndWriting
											.difficultiesWith
											.gettingThoughtsOntoPaper
									}
									hasLongIntro={hasLongIntro}
								/>
								<InfoRowBool
									notAvailable={notAvailable}
									name={strings.difficultyReadWriteEnglish}
									value={
										testUser.readingAndWriting
											.difficultiesWith
											.readingAndWritingEnglish
									}
									hasLongIntro={hasLongIntro}
								/>
								<InfoRowBool
									notAvailable={notAvailable}
									name={strings.assessedReadingWritingQuestion}
									value={
										testUser.readingAndWriting
											.hasBeenAssessedForDifficulties
									}
									hasLongIntro={hasLongIntro}
								/>

								<InfoRowBool
									notAvailable={notAvailable}
									condition={
										testUser.readingAndWriting
											.hasBeenAssessedForDifficulties
									}
									name={strings.hasDyslexiaDiagnosisQuestion}
									value={
										testUser.readingAndWriting.hasDiagnosis
									}
									hasLongIntro={hasLongIntro}
								/>

								<InfoRowBool
									notAvailable={notAvailable}
									condition={
										!testUser.readingAndWriting
											.hasBeenAssessedForDifficulties
									}
									name={strings.suspectsDyslexiaQuestion}
									value={
										testUser.readingAndWriting
											.suspectsToHaveDyslexia
									}
									hasLongIntro={hasLongIntro}
								/>

								<InfoRow
									name={
										strings.familyReadingWritingDyslexiaQuestion
									}
									hasLongIntro={hasLongIntro}
								>
									{testUser.readingAndWriting
										.closeRelativeHasDifficulties ===
										'yes' && 'Ja'}
									{testUser.readingAndWriting
										.closeRelativeHasDifficulties ===
										'no' && 'Nei'}
									{testUser.readingAndWriting
										.closeRelativeHasDifficulties ===
										'doesNotKnow' && strings.answerDoesNotKnow}
								</InfoRow>
								<InfoRow
									name={strings.rateReadingWritingSkillsQuestion}
									value={
										testUser.readingAndWriting.selfRating
									}
									hasLongIntro={hasLongIntro}
								/>
							</div>
						)}

					{this.props.testType !== 'child-screening' && (
						<div>
							<div className="info__group info__group--math">
								<h3>{strings.mathHeading}</h3>
								<InfoRowBool
									notAvailable={notAvailable}
									name={strings.mathDifficultiesQuestion}
									value={
										testUser.math
											.hasDifficultiesWithMathOrCalculation
									}
									hasLongIntro={hasLongIntro}
								/>
								<InfoRowBool
									notAvailable={notAvailable}
									name={
										strings.assessedMathDifficultiesQuestion
									}
									value={
										testUser.math
											.hasBeenAssessedForDifficulties
									}
									hasLongIntro={hasLongIntro}
								/>
								<InfoRowBool
									notAvailable={notAvailable}
									condition={
										testUser.math
											.hasBeenAssessedForDifficulties
									}
									name={strings.diagnosisDyscalculiaQuestion}
									value={testUser.math.hasDiagnosis}
								/>

								<InfoRowBool
									notAvailable={notAvailable}
									condition={
										!testUser.math
											.hasBeenAssessedForDifficultie
									}
									name={strings.suspectDyscalculiaQuestion}
									value={
										testUser.math.suspectsToHaveDyscalculia
									}
									hasLongIntro={hasLongIntro}
								/>

								<InfoRow
									name={strings.familyMathDyscalculiaQuestion}
									hasLongIntro={hasLongIntro}
								>
									{testUser.math
										.closeRelativeHasDifficulties ===
										'yes' && 'Ja'}
									{testUser.math
										.closeRelativeHasDifficulties ===
										'no' && 'Nei'}
									{testUser.math
										.closeRelativeHasDifficulties ===
										'doesNotKnow' && strings.answerDoesNotKnow}
								</InfoRow>
								<InfoRow
									name={strings.rateOwnMathQuestion}
									value={testUser.math.selfRating}
									hasLongIntro={hasLongIntro}
								/>
							</div>
							<div className="info__group info__group--adhd">
								<h3>{strings.concentrationHeading}</h3>
								<InfoRowBool
									notAvailable={notAvailable}
									name={strings.concentrationStaminaQuestion}
									value={
										testUser.adhd
											.hasDifficultiesWithConcentrationAndStamina
									}
									hasLongIntro={hasLongIntro}
								/>
								<InfoRowBool
									notAvailable={notAvailable}
									name={strings.easilyBoredRestlessQuestion}
									value={testUser.adhd.easilyBoredAndRestless}
									hasLongIntro={hasLongIntro}
								/>
								<InfoRowBool
									notAvailable={notAvailable}
									name={strings.assessedAddAdhdQuestion}
									value={
										testUser.adhd
											.hasBeenAssessedForDifficulties
									}
									hasLongIntro={hasLongIntro}
								/>
								{testUser.adhd
									.hasBeenAssessedForDifficulties && (
									<InfoRowBool
										notAvailable={notAvailable}
										name={strings.diagnosisAddAdhdQuestion}
										value={testUser.adhd.hasDiagnosis}
										hasLongIntro={hasLongIntro}
									/>
								)}
								{!testUser.adhd
									.hasBeenAssessedForDifficulties && (
									<InfoRowBool
										notAvailable={notAvailable}
										name={strings.suspectAddAdhdQuestion}
										value={
											testUser.adhd
												.suspectsToHaveAddOrAdhd
										}
										hasLongIntro={hasLongIntro}
									/>
								)}
								<InfoRow
									name={strings.familyAddAdhdQuestion}
									hasLongIntro={hasLongIntro}
								>
									{testUser.adhd
										.closeRelativeHasDifficulties ===
										'yes' && 'Ja'}
									{testUser.adhd
										.closeRelativeHasDifficulties ===
										'no' && 'Nei'}
									{testUser.adhd
										.closeRelativeHasDifficulties ===
										'doesNotKnow' && strings.answerDoesNotKnow}
								</InfoRow>
								<InfoRow
									name={strings.rateOwnConcentrationQuestion}
									value={testUser.adhd.selfRating}
									hasLongIntro={hasLongIntro}
								/>
							</div>
						</div>
					)}
				</div>
			</div>
		);
	}
}

export default TestUserInfo;
